import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { QuestionsService } from '../services/questions.service';
import { inject } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

const activeQuestionnaireInstanceGuidStorageKey =
  'activeQuestionnaireInstanceGuid';

export const needCurrentQuestionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const questionService = inject(QuestionsService);
  const router = inject(Router);

  if (questionService.currentQuestion()) {
    return true;
  }
  // if service has no current question check if we can resume an instance
  const guid =
    router.getCurrentNavigation()?.extras.state?.[
      'activeQuestionnaireInstanceGuid'
    ] ??
    route.queryParamMap.get('questionnaireInstanceGuid') ??
    sessionStorage.getItem(activeQuestionnaireInstanceGuidStorageKey);
  if (!guid) {
    return router.createUrlTree(['/details']);
  }

  return questionService.resumeInstance(guid).pipe(
    map((success) => (success ? true : router.createUrlTree(['/details']))),
    catchError(() => of(router.createUrlTree(['/details']))),
  );
};
